import { spawn } from 'redux-saga/effects';

import { watchGetStatesByCountries } from './getStatesByCountries';

export default function* saga() {
  yield spawn(watchGetStatesByCountries);
}
